(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[108],{

/***/ 4942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/responsible-tax-management",
      function () {
        return __webpack_require__(1003);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8077);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4115);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8017);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);





var ResponsibleTaxManagement = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "101Digital | Responsible Tax Management"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                as: "h1",
                textStyle: "h1",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "136px"
                ],
                mt: [
                    "45px",
                    null,
                    null,
                    null,
                    null,
                    "132px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    children: "Responsible Tax Management"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                maxW: "1155px",
                w: "100%",
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "99px"
                ],
                px: [
                    "28px",
                    null,
                    null,
                    null,
                    null,
                    "16px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    textStyle: "paragraph",
                    color: "primary",
                    fontSize: [
                        "12px",
                        null,
                        null,
                        null,
                        null,
                        "21px"
                    ],
                    fontWeight: 300,
                    children: [
                        "101 Digital PTE is committed to complying with applicable tax laws and regulations by paying our fair share of taxes across all countries in which we operate. These include all taxes that we incur, as well as tax that we collect from our customers, such as witholding taxes. Our key principles in relation to tax management are:",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "1. We maintain an open and transparent relationship with tax authorities based on trust & respect.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                        }),
                        "2. We only undertake transactions which are strictly associated with genuine commercial activities."
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ResponsibleTaxManagement);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,77,774,888,179], function() { return __webpack_exec__(4942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);